import * as React from 'react';
import { IconProps } from '../types';

const IcExport = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
     <path
      fill={props?.fill ?? '#232F3E'}
      d="M4.625 22a2.407 2.407 0 0 1-1.766-.734 2.407 2.407 0 0 1-.734-1.766v-3.75h2.5v3.75h15v-3.75h2.5v3.75c0 .688-.245 1.276-.735 1.766S20.312 22 19.625 22h-15Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M13.374 2v10.188l3.25-3.25 1.75 1.812-6.25 6.25-6.25-6.25 1.75-1.813 3.25 3.25V2h2.5Z"
    />
  </svg>
);

export default IcExport;
